export const morrApiURL:string = process.env.REACT_APP_API_SERVER_URL ||  'https://morr-api.herokuapp.com/api/v1';